import { createContext, useContext, useMemo } from 'react';
import { useLocation } from 'react-router-dom';
import constants from '../constants';

const LeagueType = createContext();

export function LeagueTypeProvider({ children }) {
  const { pathname } = useLocation();
  
  // localLeagues/genderLeagues must be checked before leagues —
  // 'leagues' is a substring of both 'local-leagues' and 'gender-leagues'
  const getLeagueType = () => {
    if (pathname.indexOf(constants.pages.localLeagues) !== -1) {
      return constants.pages.localLeagues;
    }
    if (pathname.indexOf(constants.pages.genderLeagues) !== -1) {
      return constants.pages.genderLeagues;
    }
    return constants.pages.leagues;
  };

  const leagueType = getLeagueType();

  const value = useMemo(() => ({ leagueType }), [leagueType]);

  return (
    <LeagueType.Provider value={value}>
      {children}
    </LeagueType.Provider>
  );
}

// Custom hook for convenience
export function useLeagueTypeProvider() {
  return useContext(LeagueType);
}